import { render, staticRenderFns } from "./EditSeguroistatuPage.vue?vue&type=template&id=4f61e337&"
import script from "./EditSeguroistatuPage.vue?vue&type=script&lang=js&"
export * from "./EditSeguroistatuPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports